import { callApi } from 'services/api/api'
import { baseURL } from 'services/api/apiConfig'

export async function startWebSocketSession() {
  try {
    await callApi(`${baseURL}/wss/session`, 'POST')
    console.log('WebSocket session cookie set')
  } catch (error) {
    console.error('Failed to start WebSocket session', error)
    // toastStore.createToast(TOAST_TYPE.ERROR, 'Session error', 'Unable to start WebSocket session')
  }
}
